import React from "react";
import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/context/Lang";
import { SERVICES } from "@/data";
import { Reveal, Overline } from "@/components/site/Reveal";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export default function Services() {
  const { t, lang } = useLang();
  return (
    <section id="services" className="bg-[#F8F9FA] py-24 md:py-32" data-testid="services">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <Reveal className="max-w-3xl mb-14">
          <Overline>{t.services.overline}</Overline>
          <h2 className="mt-4 font-display font-extrabold text-navy text-4xl md:text-6xl leading-[0.95] tracking-tighter">
            {t.services.title}
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 auto-rows-[240px] gap-4 md:gap-6">
          {SERVICES.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Wrench;
            const c = s[lang];
            return (
              <Reveal
                key={s.id}
                delay={i * 0.05}
                className={`group relative overflow-hidden bg-navy border border-navy/10 ${s.span}`}
              >
                <div className="absolute inset-0" data-testid={`service-${s.id}`}>
                  <img
                    src={s.img}
                    alt={`${c.title} — ${c.desc} | Seven Home Services, Winter Garden, FL`}
                    className="w-full h-full object-cover opacity-40 group-hover:opacity-55 group-hover:scale-105 transition-[transform,opacity] duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/70 to-navy/20" />
                </div>
                <div className="relative z-10 h-full p-6 flex flex-col justify-between">
                  <div className="w-12 h-12 flex items-center justify-center bg-orange text-white rounded-sm">
                    <Icon size={22} />
                  </div>
                  <div>
                    <h3 className="font-display font-bold text-white text-xl md:text-2xl tracking-tight leading-tight">
                      {c.title}
                    </h3>
                    <p className="mt-2 text-white/65 text-sm leading-relaxed max-w-xs">{c.desc}</p>
                    <button
                      onClick={() => scrollTo("quote")}
                      data-testid={`service-cta-${s.id}`}
                      className="mt-4 inline-flex items-center gap-1.5 text-orange font-bold text-sm group/btn"
                    >
                      {t.services.cta}
                      <ArrowUpRight size={16} className="group-hover/btn:translate-x-1 group-hover/btn:-translate-y-1 transition-transform" />
                    </button>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
